<div class="fixed bottom-3 left-0 right-0 mx-auto w-11/12 max-w-[400px] bg-surface-container-lowest backdrop-blur-xl border border-on-surface-variant rounded-full shadow-primary-glow-sm flex items-center justify-between px-3 py-1 z-[997]">
  <div class="flex-1 flex justify-center">
    <app-link route="/client" type="none" class="w-full">
      <div class="flex flex-col items-center justify-center py-1 transition-colors"
           [ngClass]="{ 'text-primary': isResumeActive(), 'text-on-surface-variant hover:text-on-background': !isResumeActive() }">
        <ion-icon name="grid-outline" class="text-xl"></ion-icon>
        <span class="text-3xs font-semibold mt-1 text-center whitespace-nowrap">{{ 'menu.resume' | translate }}</span>
      </div>
    </app-link>
  </div>

  <div *ngIf="!hasCustomerOperationalBlockReasons()" class="flex-1 flex justify-center">
    <app-link route="{{allPortfoliosUrl()}}" type="none" class="w-full">
      <div class="flex flex-col items-center justify-center py-1 transition-colors"
           [ngClass]="{ 'text-primary': isAllPortfoliosActive(), 'text-on-surface-variant hover:text-on-background': !isAllPortfoliosActive() }">
        <ion-icon name="albums-outline" class="text-xl"></ion-icon>
        <span class="text-3xs font-medium mt-1 text-center whitespace-nowrap">{{ 'menu.tabAllProducts' | translate }}</span>
      </div>
    </app-link>
  </div>

  <div class="flex-none px-2">
    <button (click)="toggleOperations()"
            class="w-12 h-12 rounded-full bg-primary text-white flex items-center justify-center shadow-primary-fab transition-all duration-300 relative focus:outline-none"
            [ngClass]="{ 'bg-error shadow-aggressive': operationsOpen }">
      <span class="sr-only">{{ 'menu.sectionOperativa' | translate }}</span>
      <div class="block w-5 absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2">
        <span aria-hidden="true" class="block absolute h-0.5 w-5 bg-current transform transition duration-500 ease-in-out"
              [ngClass]="{ 'rotate-45': operationsOpen, '-translate-y-1.5': !operationsOpen }">
        </span>
        <span aria-hidden="true" class="block absolute h-0.5 w-5 bg-current transform transition duration-500 ease-in-out"
              [ngClass]="{ 'opacity-0': operationsOpen }">
        </span>
        <span aria-hidden="true" class="block absolute h-0.5 w-5 bg-current transform transition duration-500 ease-in-out"
              [ngClass]="{ '-rotate-45': operationsOpen, 'translate-y-1.5': !operationsOpen }">
        </span>
      </div>
    </button>
  </div>

  <div *ngIf="!hasCustomerOperationalBlockReasons()" class="flex-1 flex justify-center">
    <app-link route="/client/plan/create" type="none" class="w-full">
      <div class="flex flex-col items-center justify-center py-1 transition-colors"
           [ngClass]="{ 'text-primary': isNewPlanActive(), 'text-on-surface-variant hover:text-on-background': !isNewPlanActive() }">
        <ion-icon name="add-circle-outline" class="text-xl"></ion-icon>
        <span class="text-3xs font-medium mt-1 text-center whitespace-nowrap">{{ 'menu.tabNewPlan' | translate }}</span>
      </div>
    </app-link>
  </div>

  <div *ngIf="canShowPromotionsButton(); else inviteButton" class="flex-1 flex justify-center">
    <app-link route="/client/invite/promotions" type="none" class="w-full">
      <div class="flex flex-col items-center justify-center py-1 transition-colors"
           [ngClass]="{ 'text-primary': isPromotionsActive(), 'text-on-surface-variant hover:text-on-background': !isPromotionsActive() }">
        <ion-icon name="gift-outline" class="text-xl"></ion-icon>
        <span class="text-3xs font-medium mt-1 text-center whitespace-nowrap">{{ 'menu.promotions' | translate }}</span>
      </div>
    </app-link>
  </div>

  <ng-template #inviteButton>
    <div class="flex-1 flex justify-center">
      <app-link route="/client/invite/share" type="none" class="w-full">
        <div class="flex flex-col items-center justify-center py-1 transition-colors"
             [ngClass]="{ 'text-primary': isInviteActive(), 'text-on-surface-variant hover:text-on-background': !isInviteActive() }">
          <ion-icon name="person-add-outline" class="text-xl"></ion-icon>
          <span class="text-3xs font-medium mt-1 text-center whitespace-nowrap">{{ 'menu.invite' | translate }}</span>
        </div>
      </app-link>
    </div>
  </ng-template>
</div>

<div *ngIf="profileOpen && !hasCustomerOperationalBlockReasons()"
  (click)="closeProfile()"
  class="fixed inset-0 backdrop-blur-sm transition-all duration-300 z-[998]">
</div>

<div
  *ngIf="!hasCustomerOperationalBlockReasons()"
  class="customer-area-profile-menu fixed bottom-22 left-0 right-0 mx-auto w-11/12 max-w-[340px] bg-surface-container-lowest rounded-3xl p-5 border border-surface-container shadow-primary-glow-sm transform z-[999] overflow-y-auto max-h-[70vh] flex flex-col gap-1 translate-y-10 opacity-0 scale-95 pointer-events-none"
  [ngClass]="{
       'transition-all duration-300': isTransitionReady,
       'translate-y-0 opacity-100 scale-100': profileOpen,
       'translate-y-10 opacity-0 scale-95 pointer-events-none': !profileOpen
     }">
  <div *ngIf="loggedUser" class="flex items-center gap-3 px-3 py-2 border-b border-outline-variant mb-2">
    <div class="w-9 h-9 rounded-full bg-surface-container-low flex items-center justify-center">
      <ion-icon class="text-xl text-on-surface-variant" name="person-outline"></ion-icon>
    </div>
    <div class="flex flex-col">
      <p class="text-sm font-bold text-on-background">{{ loggedUser.userData.name }}</p>
    </div>
  </div>

  <button (click)="goToProfileOption('/client/profile/personal-data')"
          class="flex items-center gap-3 w-full px-4 py-3 rounded-2xl hover:bg-surface-container-low active:bg-surface-container-low transition-colors text-left text-on-background focus:outline-none">
    <ion-icon name="person-outline" class="text-xl text-on-surface-variant"></ion-icon>
    <span class="text-sm font-semibold">{{ 'menu.personalData' | translate }}</span>
  </button>

  <button (click)="goToProfileOption('/client/profile/documents')"
          class="flex items-center gap-3 w-full px-4 py-3 rounded-2xl hover:bg-surface-container-low active:bg-surface-container-low transition-colors text-left text-on-background focus:outline-none">
    <ion-icon name="document-text-outline" class="text-xl text-on-surface-variant"></ion-icon>
    <span class="text-sm font-semibold">{{ 'menu.fiscalReports' | translate }}</span>
  </button>

  <button *ngIf="!doPartnerProvidesUserData()" (click)="goToProfileOption('/client/profile/configuration')"
          class="flex items-center gap-3 w-full px-4 py-3 rounded-2xl hover:bg-surface-container-low active:bg-surface-container-low transition-colors text-left text-on-background focus:outline-none">
    <ion-icon name="settings-outline" class="text-xl text-on-surface-variant"></ion-icon>
    <span class="text-sm font-semibold">{{ 'menu.appConfiguration' | translate }}</span>
  </button>

  <button (click)="goToProfileOption('/client/help')"
          class="flex items-center gap-3 w-full px-4 py-3 rounded-2xl hover:bg-surface-container-low active:bg-surface-container-low transition-colors text-left text-on-background focus:outline-none">
    <ion-icon name="help-circle-outline" class="text-xl text-on-surface-variant"></ion-icon>
    <span class="text-sm font-semibold">{{ 'menu.help' | translate }}</span>
  </button>

  <button (click)="toggleTheme($event)"
          class="flex items-center gap-3 w-full px-4 py-3 rounded-2xl hover:bg-surface-container-low active:bg-surface-container-low transition-colors text-left text-on-background focus:outline-none">
    <ion-icon [name]="themeService.isDarkMode() ? 'sunny-outline' : 'moon-outline'" class="text-xl text-on-surface-variant"></ion-icon>
    <span class="text-sm font-semibold">{{ (themeService.isDarkMode() ? 'menu.lightMode' : 'menu.darkMode') | translate }}</span>
  </button>

  <button *ngIf="shouldShowButtonLogout()" (click)="goToProfileOption('/client/logout')"
          class="flex items-center gap-3 w-full px-4 py-3 rounded-2xl hover:bg-surface-container-low active:bg-surface-container-low transition-colors text-left text-on-background focus:outline-none">
    <ion-icon name="close-circle-outline" class="text-xl text-on-surface-variant"></ion-icon>
    <span class="text-sm font-semibold">{{ 'menu.logout' | translate }}</span>
  </button>
</div>

<div *ngIf="operationsOpen" (click)="closeOperations()"
  class="fixed inset-0 backdrop-blur-sm transition-all duration-300 z-[998]">
</div>

<div
  class="customer-area-quick-actions fixed bottom-22 left-0 right-0 mx-auto w-11/12 max-w-[340px] bg-surface-container-lowest rounded-3xl p-3 border border-surface-container shadow-primary-glow-sm transform z-[999] overflow-y-auto max-h-[75vh] flex flex-col gap-1 translate-y-10 opacity-0 scale-95 pointer-events-none"
  [ngClass]="{
       'transition-all duration-300': isTransitionReady,
       'translate-y-0 opacity-100 scale-100': operationsOpen,
       'translate-y-10 opacity-0 scale-95 pointer-events-none': !operationsOpen
     }">

  <div *ngIf="!isNewProductScreen()" class="w-full">
    <p class="text-xs font-extrabold text-on-surface-variant uppercase tracking-[0.12em] mb-1 px-1">{{ 'menu.sectionOperativa' | translate }}</p>
    <div class="grid grid-cols-2 gap-1">
      <button *ngIf="canShowRegularCashTransferIn() && !hasCustomerOperationalBlockReasons()"
        (click)="goToOperation(regularCashTransferInUrl())"
        class="flex flex-col items-center gap-1 px-1 py-2 hover:bg-surface-container-low rounded-xl transition-colors">
        <div class="w-9 h-9 rounded-full bg-primary-background text-primary flex items-center justify-center text-lg">
          <ion-icon name="bar-chart-outline" class="text-xl"></ion-icon>
        </div>
        <span class="text-xs font-semibold text-on-background text-center">{{ 'menu.regularMonetaryContribution' | translate }}</span>
      </button>

      <button *ngIf="canShowExtraordinaryCashTransferIn() && !hasCustomerOperationalBlockReasons()"
        (click)="goToOperation(extraordinaryCashTransferInUrl())"
        class="flex flex-col items-center gap-1 px-1 py-2 hover:bg-surface-container-low rounded-xl transition-colors">
        <div class="w-9 h-9 rounded-full bg-primary-background text-primary flex items-center justify-center text-lg">
          <ion-icon name="paper-plane-outline" class="text-xl"></ion-icon>
        </div>
        <span class="text-xs font-semibold text-on-background text-center">{{ 'menu.extraordinaryMonetaryContribution' | translate }}</span>
      </button>

      <button *ngIf="canShowDeposit() && !hasCustomerOperationalBlockReasons()"
        (click)="goToOperation(depositUrl())"
        class="flex flex-col items-center gap-1 px-1 py-2 hover:bg-surface-container-low rounded-xl transition-colors">
        <div class="w-9 h-9 rounded-full bg-primary-background text-primary flex items-center justify-center text-lg">
          <ion-icon name="paper-plane-outline" class="text-xl"></ion-icon>
        </div>
        <span class="text-xs font-semibold text-on-background text-center">{{ 'menu.deposit' | translate }}</span>
      </button>

      <button *ngIf="canShowInvestmentTransferFundsButton() && !hasCustomerOperationalBlockReasons()"
        (click)="goToOperation(investmentTransferFundsUrl())"
        class="flex flex-col items-center gap-1 px-1 py-2 hover:bg-surface-container-low rounded-xl transition-colors">
        <div class="w-9 h-9 rounded-full bg-surface-container text-on-surface-variant flex items-center justify-center text-lg">
          <ion-icon name="shuffle-outline" class="text-xl"></ion-icon>
        </div>
        <span class="text-xs font-semibold text-on-background text-center">{{ 'menu.transferFunds' | translate }}</span>
      </button>

      <button *ngIf="canShowPensionPlanTransferButton() && !hasCustomerOperationalBlockReasons()"
        (click)="goToOperation('/client/pension-plan/transfer')"
        class="flex flex-col items-center gap-1 px-1 py-2 hover:bg-surface-container-low rounded-xl transition-colors">
        <div class="w-9 h-9 rounded-full bg-surface-container text-on-surface-variant flex items-center justify-center text-lg">
          <ion-icon name="shuffle-outline" class="text-xl"></ion-icon>
        </div>
        <span class="text-xs font-semibold text-on-background text-center">{{ 'menu.transferPlan' | translate }}</span>
      </button>

      <button *ngIf="canShowWithdrawal() && !hasCustomerOperationalBlockReasons()"
        (click)="goToOperation('/client/withdrawal')"
        class="flex flex-col items-center gap-1 px-1 py-2 hover:bg-surface-container-low rounded-xl transition-colors">
        <div class="w-9 h-9 rounded-full bg-surface-container text-on-surface-variant flex items-center justify-center text-lg">
          <ion-icon name="download-outline" class="text-xl"></ion-icon>
        </div>
        <span class="text-xs font-semibold text-on-background text-center">{{ 'menu.withdrawal' | translate }}</span>
      </button>

      <button *ngIf="canShowPortfolioConfigurationButton() && !hasCustomerOperationalBlockReasons()"
        (click)="goToOperation('/client/portfolio-configuration/data')"
        class="flex flex-col items-center gap-1 px-1 py-2 hover:bg-surface-container-low rounded-xl transition-colors">
        <div class="w-9 h-9 rounded-full bg-surface-container text-on-surface-variant flex items-center justify-center text-lg">
          <ion-icon name="settings-outline" class="text-xl"></ion-icon>
        </div>
        <span class="text-xs font-semibold text-on-background text-center">{{ 'menu.planConfiguration' | translate }}</span>
      </button>

      <button *ngIf="canShowPremiumButton() && !hasCustomerOperationalBlockReasons()"
        (click)="showPremiumModal(); closeOperations()"
        class="flex flex-col items-center gap-1 px-1 py-2 hover:bg-surface-container-low rounded-xl transition-colors">
        <div class="w-9 h-9 rounded-full bg-surface-container text-premium flex items-center justify-center text-lg">
          <ion-icon name="arrow-up-outline" class="text-xl text-premium"></ion-icon>
        </div>
        <span class="text-xs font-semibold text-on-background text-center">{{ 'menu.upgradePremium' | translate }}</span>
      </button>
    </div>
  </div>

  <div *ngIf="!isNewProductScreen()" class="border-t border-outline-variant my-2 w-full"></div>

  <div *ngIf="!isNewProductScreen()" class="w-full">
    <p class="text-xs font-extrabold text-on-surface-variant uppercase tracking-[0.12em] mb-1 px-1">{{ 'menu.sectionConsulta' | translate }}</p>
    <div class="grid grid-cols-2 gap-1">
      <button (click)="goToOperation('/client/last-movements')"
        class="flex flex-col items-center gap-1 px-1 py-2 hover:bg-surface-container-low rounded-xl transition-colors">
        <div class="w-9 h-9 rounded-full bg-surface-container text-on-surface-variant flex items-center justify-center text-lg">
          <ion-icon name="list-outline" class="text-xl"></ion-icon>
        </div>
        <span class="text-xs font-semibold text-on-background text-center">{{ 'shared.movements' | translate | titlecase }}</span>
      </button>

      <button *ngIf="isSelectedPortfolioEnabled() && !hasCustomerOperationalBlockReasons()"
        (click)="goToOperation('/client/portfolio/progress')"
        class="flex flex-col items-center gap-1 px-1 py-2 hover:bg-surface-container-low rounded-xl transition-colors">
        <div class="w-9 h-9 rounded-full bg-surface-container text-on-surface-variant flex items-center justify-center text-lg">
          <ion-icon name="pulse-outline" class="text-xl"></ion-icon>
        </div>
        <span class="text-xs font-semibold text-on-background text-center">{{ 'menu.portfolioProgress' | translate }}</span>
      </button>

      <button *ngIf="isSelectedPortfolioEnabled() && !hasCustomerOperationalBlockReasons()"
        (click)="goToOperation('/client/simulator/menu')"
        class="flex flex-col items-center gap-1 px-1 py-2 hover:bg-surface-container-low rounded-xl transition-colors">
        <div class="w-9 h-9 rounded-full bg-surface-container text-on-surface-variant flex items-center justify-center text-lg">
          <ion-icon name="calculator-outline" class="text-xl"></ion-icon>
        </div>
        <span class="text-xs font-semibold text-on-background text-center">{{ 'menu.investmentSimulator' | translate }}</span>
      </button>

      <button *ngIf="shouldShowFeesMenuButton() && !hasCustomerOperationalBlockReasons()"
        (click)="goToOperation(redirectRouteFeesPage())"
        class="flex flex-col items-center gap-1 px-1 py-2 hover:bg-surface-container-low rounded-xl transition-colors">
        <div class="w-9 h-9 rounded-full bg-surface-container text-on-surface-variant flex items-center justify-center text-lg">
          <ion-icon name="logo-euro" class="text-xl"></ion-icon>
        </div>
        <span class="text-xs font-semibold text-on-background text-center">{{ 'shared.fees' | translate }}</span>
      </button>

      <button *ngIf="canShowPortfolioConfigurationButton() && !hasCustomerOperationalBlockReasons()"
        (click)="goToOperation('/client/portfolio-configuration/documents')"
        class="flex flex-col items-center gap-1 px-1 py-2 hover:bg-surface-container-low rounded-xl transition-colors">
        <div class="w-9 h-9 rounded-full bg-surface-container text-on-surface-variant flex items-center justify-center text-lg">
          <ion-icon name="document-text-outline" class="text-xl"></ion-icon>
        </div>
        <span class="text-xs font-semibold text-on-background text-center">{{ 'menu.productDocumentation' | translate }}</span>
      </button>
    </div>
  </div>

  <div *ngIf="!isNewProductScreen()" class="border-t border-outline-variant my-2 w-full"></div>
  <div class="flex flex-col gap-1 w-full">
    <button *ngIf="canShowRecommendUsButton() && !hasCustomerOperationalBlockReasons() && !isNewProductScreen() && isRecommendUsButtonOfTypeFriendPlan()"
            (click)="goToOperation('/client/invite')"
            class="flex items-center gap-3 w-full px-4 py-2 rounded-xl hover:bg-surface-container-low active:bg-surface-container-low transition-colors text-left focus:outline-none">
      <ion-icon name="person-add-outline" class="text-xl text-primary"></ion-icon>
      <span class="text-sm font-semibold text-primary">{{ 'menu.friendPlanWithoutFees' | translate:{money: amountWithoutFees() | money:0} }}</span>
    </button>

    <button *ngIf="canShowRecommendUsButton() && !hasCustomerOperationalBlockReasons() && !isNewProductScreen() && !isRecommendUsButtonOfTypeFriendPlan()"
            (click)="goToOperation('/client/invite')"
            class="flex items-center gap-3 w-full px-4 py-2 rounded-xl hover:bg-surface-container-low active:bg-surface-container-low transition-colors text-left focus:outline-none">
      <ion-icon name="share-social-outline" class="text-xl text-primary"></ion-icon>
      <span class="text-sm font-semibold text-primary">{{ 'menu.recommendUs' | translate }}</span>
    </button>

    <button (click)="goToOperation('/client/help')"
            class="flex items-center gap-3 w-full px-4 py-2 rounded-xl hover:bg-surface-container-low active:bg-surface-container-low transition-colors text-left text-on-background focus:outline-none">
      <ion-icon name="help-circle-outline" class="text-xl text-on-surface-variant"></ion-icon>
      <span class="text-sm font-semibold">{{ 'menu.help' | translate }}</span>
    </button>
  </div>
</div>
